import { useState, useEffect } from "react";
import useSWR from "swr";

const fetcher = (url) => fetch(url).then((res) => res.json());

const StreamsInfo = () => {
  const [streamInfor, setStreamInfo] = useState("");

  const { data, error } = useSWR(
    "https://radiobruceapis.netlify.app/.netlify/functions/api/radiostations",
    fetcher
  );

  useEffect(() => {
    if (!error && data) {
      setStreamInfo(data);
    }
  }, [data, error]);

  return {
    streamInfor,
  };
};

export default StreamsInfo;
